// extracted by mini-css-extract-plugin
export default {"uninhabitablePlanetsList__container":"UninhabitablePlanetsList_uninhabitablePlanetsList__container__hh94V"};